import React from "react";
import * as S from "../../constants/StringConstants";
import "./Footer.scss";

const Footer: React.FC = () => {
  return (
    <div className="footer">
        <div className="footer__images">
            <div className="footer__logo" />
            <div className="footer__contacts" />
        </div>
        <span className="footer__copyright">©{new Date().getFullYear()} {S.LOGIN_FOOTER_COPYRIGHT}</span>
    </div>
  );
};

export default Footer;